export const styles = theme => ({
  boxLevel: {
    border: `1px solid ${theme.palette.line.main}`,
    '&:nth-of-type(even)': {
      borderRight: '0px solid #ccc',
      borderLeft: '0px solid #ccc',
    },
  },
  title: {
    textAlign: 'center',
    fontSize: '9px',
    fontFamily: theme.typography.fontKanit,
    height: '24px',
    margin: 'auto',
  },
  btnDam: {
    [theme.breakpoints.down('xs')]: {
      padding: '0px 10px !important',
    },
  },
  color: {
    fontSize: '0.7rem',
    textAlign: 'center',
    fontFamily: theme.typography.fontKanit,
    height: '24px',
    margin: 'auto',
  },
  one: {
    background: '#FFC100',
    constrastColor: '#000',
  },
  two: {
    background: '#00B050',
    constrastColor: '#000',
  },
  three: {
    background: '#003CFA',
    constrastColor: '#fff',
  },
  four: {
    color: '#fff',
    background: '#FF0000',
    constrastColor: '#fff',
  },
  five: {
    color: '#fff',
    background: '#C70200',
    constrastColor: '#fff',
  },
});